import * as React from 'react';
import ReactDOM from 'react-dom';
import Variable from 'sma.fs/surveys/variable';
import FileUploadField from './FileUploadField';
import FileUploadOptions from './FileUploadOptions';
import Fields from '../base-field';
import Value from '../model/value';
import configuration from './configuration';
import getComponentWithTheme from '../../../../themeProvider';

const UploadField = $.klass(Fields.Field, {
	type: 'file-upload',
	qlass: 'upload-field',
	cssType: 'upload-field',
	displayName: gettext('File Upload'),
	isEnabled: true,
	isVisible: true,
	isCustom: true,

	// Initialize with default configurations
	config: {
		allowMultiple: configuration.defaults.allowMultiple,
		limitUploads: configuration.defaults.limitUploads,
		limitFileFormat: configuration.defaults.limitFileFormat,
		includeDescription: configuration.defaults.includeDescription,
		min: configuration.defaults.minFiles,
		max: configuration.defaults.maxFiles,
		maxFileSize: configuration.defaults.maxFileSize,
		fileFormats: configuration.defaults.fileFormats,
		required: configuration.defaults.required,
	},

	initialize($super, info, editor) {
		const config = info || {};
		$super(config, editor);

		// Set default values on initialize (seems that .klass lowepro stuff copies instances :\)
		this.config = {
			allowMultiple: configuration.defaults.allowMultiple,
			limitUploads: configuration.defaults.limitUploads,
			limitFileFormat: configuration.defaults.limitFileFormat,
			includeDescription: configuration.defaults.includeDescription,
			min: configuration.defaults.minFiles,
			max: configuration.defaults.maxFiles,
			maxFileSize: configuration.defaults.maxFileSize,
			fileFormats: configuration.defaults.fileFormats,
			required: configuration.defaults.required,
		},

		this.deserialize(config);
		this.input = $('<div class="file-upload"></div>');
	},

	render($super) {
		$super();
		this.element.append(this.input);
		const element = React.createElement(FileUploadField, {
			...this.config,
			required: !this.optional.value,
			appendToPrevious: this.appendToPrevious,
			disabled: true, // Field is always disabled on the survey builder
		});
		ReactDOM.render(
			getComponentWithTheme(
				<>
					{element}
				</>,
				window.LOCALE.theme,
			),
			this.input[0],
		);
	},

	showOptions($super, options) {
		$super(options);
		const handleValueChange = (state) => {
			this.optional = state.optional;
			this.appendToPrevious = state.appendToPrevious;
			this.description = state.description;
			this.title = state.title;
			this.name = state.name;
			Object.keys(this.config).forEach((field) => {
				this.config[field] = state[field];
			});
			this.render();
		};

		const element = React.createElement(FileUploadOptions, {
			...this.config,
			optional: this.optional,
			appendToPrevious: this.appendToPrevious,
			handleValueChange,
			title: this.title,
			description: this.description,
			name: this.name,
		});
		ReactDOM.render(element, options[0]);
	},

	serialize($super) {
		/**
		 * Super will take care of serializing:
		 * - appendToPrevious
		 * - description
		 * - id
		 * - idname
		 * - name
		 * - title
		 * - type
		 * - width
		 * */
		const info = $super();
		info.children = [{
			type: this.type,
			maxFileSize: this.config.maxFileSize,
			includeDescription: this.config.includeDescription,
		}];

		if (this.optional.value) {
			info.children[0].required = false;
		} else {
			info.children[0].required = true;
		}

		if (this.config.allowMultiple) {
			info.children[0].allowMultiple = true;
			if (this.config.limitUploads) {
				info.children[0].limitUploads = true;
				info.children[0].min = this.config.min;
				info.children[0].max = this.config.max;
			}
		}
		if (this.config.limitFileFormat) {
			info.children[0].limitFileFormat = true;
			info.children[0].fileFormats = this.config.fileFormats;
		}
		return info;
	},

	deserialize(info) {
		// Default values
		let optional = false;
		let appendToPrevious = false;

		let config;
		if (info) {
			if (info.appendToPrevious) {
				appendToPrevious = info.appendToPrevious;
			}
			if (info.children && info.children.length) {
				config = info.children[0];
			}
		}

		if (config) {
			// Deal with params outside of config (that make it into the super Field class)
			if (config.required !== undefined) {
				optional = !info.children[0].required;
			} else {
				optional = true;
			}
			delete config.optional;
			delete config.type;

			// Remaining are field specific configuration
			Object.keys(config).forEach((field) => {
				this.config[field] = config[field];
			});
		}

		this.optional = new Value(optional);
		this.appendToPrevious = new Value(appendToPrevious);
	},

	getVariables() {
		return [new Variable.File({
			id: this.id,
			label: this.getIdentifier(),
		})];
	},
});

module.exports = UploadField;
